import { flattenObject } from '../src/client/util/flatten';

import en from './en';
import nb from './nb';
import sv from './sv';

export { en };
export { nb };
export { sv };

const locales = { en, nb, sv };

const SELF_CLOSING_BR_REGEX = /<br\s*\/?>(?!<\/br>)/gi;

const listSupportedLocales = () => Object.keys(locales);

const normalizeRichText = flatMessages => Object.keys(flatMessages).reduce((acc, key) => {
    const value = flatMessages[key];
    acc[key] = typeof value === 'string' ? value.replace(SELF_CLOSING_BR_REGEX, '<br></br>') : value;
    return acc;
}, {});

const getFlatMessages = locale => normalizeRichText(flattenObject(locales[locale].messages));

const isUntranslated = value => value === null || value === undefined || value === '';

const resolveWithFallback = (flatMessages, fallbackFlatMessages) =>
    Object.keys(fallbackFlatMessages).reduce(
        (acc, key) => {
            acc[key] = isUntranslated(flatMessages[key]) ? fallbackFlatMessages[key] : flatMessages[key];
            return acc;
        },
        {}
    );

const getFlatMessagesWithFallback = (locale, fallbackLocale = 'en') => {
    const flatMessages = getFlatMessages(locale);
    if (locale === fallbackLocale) {
        return flatMessages;
    }
    return resolveWithFallback(flatMessages, getFlatMessages(fallbackLocale));
};

const getFormats = locale => locales[locale].formats;

const getLocale = locale => ({
    messages: getFlatMessagesWithFallback(locale),
    formats: getFormats(locale),
    locale,
});

const loadLocaleFromConfig = () => {
    const { locale } = window.CONFIG;
    const defaultLocale = locale.substring(0, 2);

    // eslint-disable-next-line global-require, import/no-dynamic-require
    const publicationTranslations = normalizeRichText(flattenObject(require(`./resources/${locale}.json`)));

    const messages = resolveWithFallback(
        publicationTranslations,
        getFlatMessagesWithFallback(defaultLocale)
    );

    return {
        locale,
        formats: getFormats(defaultLocale),
        messages,
        defaultLocale,
    };
};

export default {
    listSupportedLocales,
    loadLocaleFromConfig,
    hasLocale: locale => !!locales[locale],
    getLocale,
    getFormats,
    getAllMessages: () => listSupportedLocales().reduce((p, k) => (
        { ...p, [k]: getFlatMessagesWithFallback(k) }
    ), {}),
    getFlatMessagesWithFallback,
};
